/**
 * Is a pricing payload's `prices` block safe to quote a price from?
 *
 * Pure predicate, so it is tested without standing up a component that
 * fetches on mount.
 *
 * Money is not defaultable. `Number(undefined || 0)` prints "$0 per
 * month" next to a live Subscribe button, which is not a rendering
 * glitch to the merchant — it is a false statement about what we are
 * about to charge them. The gate's job is to route those payloads to
 * the retry card instead of quoting a fabricated price.
 *
 * An unquoted Enterprise band legitimately carries null prices; every
 * caller checks `contact_sales` and returns before reaching this.
 *
 * @param {object|null} prices  `prices` off `/api/billing/pricing/`
 */
export function hasUsablePrices(prices) {
  if (!prices) return false;
  return ['monthly', 'annual'].every((field) => {
    const raw = prices[field];
    // `Number(null)` and `Number('')` are both 0 — finite, and wrong.
    // The emptiness test has to come before the numeric one.
    if (raw === null || raw === undefined || raw === '') return false;
    return Number.isFinite(Number(raw));
  });
}
